import React, { Component, Fragment } from "react";
import { Form, Select } from 'antd';
import './index.less';
const {
  Option
} = Select;
import InputContainer from '@/components/CreateFormItem/InputContainer';
import NumberContainer from '@/components/CreateFormItem/NumberContainer';
import SelectContainerOther from '@/components/CreateFormItem/SelectContainer';
import RadioContainer from '@/components/CreateFormItem/RadioContainer';
import CheckBoxContainer from '@/components/CreateFormItem/CheckBoxContainer';
import CascaderContainer from '@/components/CreateFormItem/CascaderContainer';
import FileContainer from '@/components/CreateFormItem/FileContainer';
import ImgContainer from '@/components/CreateFormItem/ImgContainer';
import DateContainer from '@/components/CreateFormItem/DateContainer';
import DateTimeContainer from '@/components/CreateFormItem/DateTimeContainer';
import DateTimeRangeContainer from '@/components/CreateFormItem/DateTimeRangeContainer';
export default class SelectContainer extends Component {
  constructor(props) {
    super(props); // 0:单行文本;2:数字;3:日期;4:日期时间;5:日期时间范围;6:单选框;7:复选框;8:下拉框;9:级联选项;10:附件上传;11:图片

    this.detailObj = {
      'text': (value, form) => <InputContainer data-inspector-line="23" data-inspector-column="31" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" data={value} form={form} />,
      'number': (value, form) => <NumberContainer data-inspector-line="24" data-inspector-column="33" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" data={value} form={form} />,
      'date': (value, form) => <DateContainer data-inspector-line="25" data-inspector-column="31" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" data={value} form={form} />,
      'dateTime': (value, form) => <DateTimeContainer data-inspector-line="26" data-inspector-column="35" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" data={value} form={form} />,
      'period': (value, form) => <DateTimeRangeContainer data-inspector-line="27" data-inspector-column="33" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" data={value} form={form} />,
      'radio': (value, form, list) => <RadioContainer data-inspector-line="28" data-inspector-column="38" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" data={value} form={form} list={list} />,
      'checkbox': (value, form, list) => <CheckBoxContainer data-inspector-line="29" data-inspector-column="41" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" data={value} form={form} list={list} />,
      'select': (value, form, list) => <SelectContainerOther data-inspector-line="30" data-inspector-column="39" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" data={value} form={form} list={list} />,
      'cascade': (value, form) => <CascaderContainer data-inspector-line="31" data-inspector-column="34" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" data={value} form={form} type="info" />,
      'annex': (value, form) => <FileContainer data-inspector-line="32" data-inspector-column="32" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" data={value} form={form} />,
      'image': (value, form) => <ImgContainer.Group data-inspector-line="33" data-inspector-column="32" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" data={value} form={form} handleImg={this.props.handleImg} />
    };
    this.state = {
      imgObj: {}
    };
  }

  formatSelectValue = value => {
    // 下拉传值处理
    const {
      fieldCode,
      isApplyNewFlag
    } = this.props.data;

    if (fieldCode && ['identity_type_code', 'education_code'].includes(fieldCode) && !isApplyNewFlag) {
      return value.itemCode;
    }

    return value.id.toString();
  };

  render() {
    const {
      data,
      list,
      sceneCode
    } = this.props;
    const options = data.fieldOptions || [];
    const {
      getFieldDecorator,
      getFieldValue
    } = this.props.form;

    if (list && list.length) {
      let nextObj = list.find(elem => elem.id === data.id);

      if (nextObj && nextObj.chooseRelList && nextObj.chooseRelList.length) {
        nextObj.chooseRelList.forEach((value, index) => {
          let obj = value.showFieldInfo;
          let childObj = list.find(elem => elem.id === obj.id);
          obj.required = true;
          obj.field = childObj.fieldName;
          obj.fieldId = childObj.id;
          obj.fieldOptions = childObj.dataOptions;
          obj.value = childObj && childObj.dataValues && childObj.dataValues.length && childObj.dataValues.map(elem => elem.fieldValue).join() || '';
          obj.fileImageValues = childObj.dataValues && childObj.dataValues.length && childObj.dataValues || null;
        });
        data.chooseRelList = nextObj.chooseRelList;
      }
    }

    const defaultValue = data.value && data.value !== 'null' && data.fieldOptions && options.length ? data.value : undefined;
    const conSelector = getFieldDecorator(JSON.stringify(data.fieldId), {
      rules: [{
        required: data.required,
        validator: (rule, value, callback) => {
          let val = value || "";

          if (data.required && val === "") {
            callback('必填项，请输入相关信息');
            return;
          }

          callback();
        }
      }],
      initialValue: defaultValue
    })(<Select data-inspector-line="83" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" disabled={data.frontUpdateFlag === 1} allowClear getPopupContainer={triggerNode => triggerNode.parentElement} placeholder={sceneCode && sceneCode == '1' && data.fieldTip ? data.fieldTip : "请选择"}>
        {options.map((value, index) => <Option data-inspector-line="85" data-inspector-column="10" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" value={this.formatSelectValue(value)} key={index}>{value.content}</Option>)}
      </Select>);
    return <Fragment>
        <div data-inspector-line="91" data-inspector-column="8" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" className="detail-sel-select detail-sel-wrap">
          <Form.Item data-inspector-line="92" data-inspector-column="10" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx">
            {conSelector}
          </Form.Item>
        </div>
        {data.chooseRelList && data.chooseRelList.length && data.chooseRelList.map((value, index) => {
        let obj = value.showFieldInfo;
        let chooseValue = data.fieldCode && ['identity_type_code', 'education_code'].includes(data.fieldCode) ? value.chooseFieldItemCode : value.chooseFieldValue;
        return chooseValue == getFieldValue(JSON.stringify(data.fieldId)) && <Form.Item data-inspector-line="100" data-inspector-column="77" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" key={index}>
              <div data-inspector-line="101" data-inspector-column="14" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" className="detail-sel-container">
                <span data-inspector-line="102" data-inspector-column="16" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" className="detail-sel-title">{obj.field}{obj.required && sceneCode != 1 && <b data-inspector-line="102" data-inspector-column="93" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx">*</b> || null}</span>
                {value.fieldTip && <span data-inspector-line="103" data-inspector-column="35" data-inspector-relative-path="src\\components\\CreateFormItem\\SelectContainer\\index.jsx" className="remind-span">{value.fieldTip}</span> || null}
                {this.detailObj[obj.fieldType](obj, this.props.form, list)}
              </div>
            </Form.Item> || null;
      }) || null}
      </Fragment>;
  }

}